import React from "react"
import {Brand, BrandManagementRequest, PaginatedResponse} from "../../../models";
import withUseRouter, {UseRouterParams} from "../../../services/router";
import {t} from "@lingui/macro";
import {TextField} from "@mui/material";
import {Autocomplete} from "@mui/lab";
import {BrandManagementServices} from "../../../services/brand-management.services";
import {ErrorResponse, RestResponse} from "@sinossi/mates-react-library";
import {MatesComponent, MatesComponentState} from "../../mates-component";

interface OptionsType {
    id: string,
    name: string
}

interface MultipleBrandAutocompleteProps extends UseRouterParams {
    updateBrands: (brands: {id: string, name: string}[]) => void
    color: string
}

interface MultipleBrandAutocompleteState extends MatesComponentState {
    value: OptionsType[]
    brands: Brand[]
    options: OptionsType[]
    brandInput: string
    timeout: any
    loading: boolean
}

class MultipleBrandAutocomplete extends React.Component<MultipleBrandAutocompleteProps, MultipleBrandAutocompleteState> {

    private readonly matesComponent: MatesComponent<MultipleBrandAutocompleteProps, MultipleBrandAutocompleteState> = new MatesComponent(this)

    constructor(props: MultipleBrandAutocompleteProps) {
        super(props)
        this.state = {
            ...this.matesComponent.setupState(),
            value: [],
            brands: [],
            options: [],
            brandInput: "",
            timeout: null,
            loading: false
        }
    }

    private fetchBrand = (input: string) => {
        if(this.state.timeout){
            clearTimeout(this.state.timeout)
        }

        this.setState(() => ({
            timeout: setTimeout(() => this.handleBrandChange(input), 1000)
        }))
    }

    private setBrandOptions = () => {
        let brandOptions: OptionsType[] = []

        let filteredOptions = this.state.brands.filter(fullItem =>
            !this.state.value.some(selectedItem => selectedItem.id === fullItem.id)
        )

        filteredOptions.map((brand) => {
            let newOption = {id: brand.id, name: brand.name}
            if(!this.state.value.includes(newOption)){
                brandOptions.push(newOption)
            }
        })

        this.setState(() => ({
            options: brandOptions
        }))
    }

    private handleBrandChange = (value: string) => {

        this.setState(() => ({
            loading: true
        }))

        if(value.length > 2){
            let request: BrandManagementRequest = {
                name: value,
                pageSize: 50
            }

            BrandManagementServices.brandManagementData(request, this.handleBrandChangeCallback, this.matesComponent.onError)
        }
    }

    private handleBrandChangeCallback = (response: RestResponse<PaginatedResponse<Brand>, ErrorResponse>) => {
        if(response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        if (response.data){
            this.setState(() => ({
                brands: response.data!.items,
                loading: false
            }), this.setBrandOptions)
        }
    }

    render() {
        return (
            <Autocomplete
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: this.props.color,
                        },
                        '&:hover fieldset': {
                            borderColor: this.props.color,
                        },
                    }
                }}
                getOptionLabel={(option) => option.name}
                filterOptions={(x) => x}
                options={this.state.options}
                autoComplete
                includeInputInList
                filterSelectedOptions
                multiple
                value={this.state.value}
                noOptionsText={t({id: "create-user-modal.no-user", message: "Nessun utente trovato."})}
                onChange={(event, newValue) => {
                    if (newValue) {
                        this.setState(() => ({
                            value: newValue,
                        }), () => this.props.updateBrands(newValue));
                    }
                }}
                onInputChange={(event, newInputValue) => {
                    this.setState({ brandInput: newInputValue }, () => {
                        if (this.state.brandInput === '') {
                            this.setState({ options: [] });
                        }
                        else {
                            this.fetchBrand(this.state.brandInput)
                        }
                    })
                }}
                renderInput={(params) => (
                    <TextField {...params}
                               sx={{color: this.props.color}}
                               label={t({id: "create-user-modal.select-user", message: "Inizia a scrivere per cercare il brand da associare..."})}
                               fullWidth
                    />
                )}
            />
        )
    }
}

export default withUseRouter(MultipleBrandAutocomplete)
